export enum AssetTypeKeys {
  /**
   * Represents a default switchgear asset.
   */
  Switchgear = "$UTP2_DEFAULT",

  /**
   * Represents a transformer asset.
   */
  Transformer = "$TRANSFORMER",

  /**
   * Represents a simplified switchgear asset.
   */
  SwitchgearSimple = "$UTP2_SIMPLE",

  /**
   * Represents a GIS (Gas Insulated Switchgear) switchgear asset.
   */
  GisSwitchgear = "$GIS_SWITCHGEAR",

  /**
   * Represents an outdoor switchyard asset.
   */
  OutdoorSwitchyard = "$OUTDOOR_SWITCHYARD",
}
